import { FC } from "react";
import CODImage from "../../Assets/homev2/COD-image.png";
import CODText from "../../Assets/homev2/COD-text.svg";
import codVideo from "../../Assets/homev2/cod-video.mp4";
import { OutlineButton } from "./Buttons";
import ContainedButton from "./Buttons/Contained";

const CampaignsOnDemand: FC = () => {
  return (
    <section className="w-full bg-black overflow-hidden max-h-[1000px] relative">
      <div className="w-full h-full max-w-[1500px] mx-auto px-2 md:px-4 pt-8 md:pt-20 flex flex-col items-center relative min-h-[480px] md:min-h-[768px] xl:min-h-[850px]">
        <div className="relative z-[1]">
          <h2 className="text-xl md:text-5xl lg:text-7xl text-white font-semibold text-center flex items-start justify-center">
            Campaigns OnDemand
            <span className="text-xl md:text-3xl font-normal">&#8482;</span>
          </h2>
          <h4 className="text-center text-white md:text-2xl mt-2 md:mt-4">
            Instant 12-person sales team. <br className="block sm:hidden" />{" "}
            Launch in 5-7 days.
          </h4>
          <div className="flex  max-w-[180px] items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
            <a
              href="https://calendly.com/salesbox-meet/salesmrkt?month=2023-08"
              className="w-full "
            >
              <ContainedButton theme="primary">Book a call</ContainedButton>
            </a>
            <a href="https://salesboxmarket.myshopify.com/" className="w-full ">
              <OutlineButton>What’s Inside</OutlineButton>
            </a>
          </div>
        </div>
        <div className="w-[600px]  lg:w-full absolute z-0 bottom-[2%] lg:bottom-0">
          <video
            src={codVideo}
            muted
            autoPlay
            playsInline
            loop
            preload="none"
            width="150%"
            height="150%"
          />
          <img
            src={CODText}
            alt=""
            className="absolute scale-75 xl:scale-100 left-[5%] xl:left-[10%] bottom-[15%] hidden lg:block"
          />
        </div>
      </div>
      <a
        href="https://salesboxmarket.myshopify.com/"
        className="absolute z-[2] hidden md:block text-[#84CC16] md:text-lg xl:text-2xl right-4 xl:right-10 bottom-4 xl:bottom-10"
      >
        Explore more revenue solutions {">"}
      </a>
    </section>
  );
};

export default CampaignsOnDemand;
